import CreateRemitAddressContainer from "./CreateRemitAddressContainer";
export default CreateRemitAddressContainer;
